import { ReactNode } from "react";
import DBObject from "./DBObject";
import * as __d3ett from "../rocket/D3ETemplateTypes";
import Result from "../classes/Result";
import { AdminBusinessDetailsPageProps } from "../components/AdminBusinessDetailsPage";
import { AdminConfigurationPageProps } from "../components/AdminConfigurationPage";
import { AdminHomePageProps } from "../components/AdminHomePage";
import { AdminDashboardPage2Props } from "../components/AdminDashboardPage2";
import { AdminCategoryManagementPageProps } from "../components/AdminCategoryManagementPage";
import { AdminBusinessManagementPageProps } from "../components/AdminBusinessManagementPage";
import { AdminLoginPageProps } from "../components/AdminLoginPage";
import { AdminSignupPageProps } from "../components/AdminSignupPage";

export default class GlobalFunctions {
  public static save: (obj: DBObject) => Promise<Result<any>>;
  public static delete: (obj: DBObject) => Promise<Result<any>>;
  public static objectSave: (obj: DBObject, create: boolean) => void;
  public static fieldChanged: (
    obj: DBObject,
    field: number,
    oldValue: any
  ) => void;
  public static objectDelete: (obj: DBObject) => void;
  public static typeInt: (obj: string) => number;
  public static types: Array<__d3ett.D3ETemplateType>;
  public static AdminBusinessDetailsPage: (
    props: AdminBusinessDetailsPageProps
  ) => ReactNode;
  public static AdminBusinessManagementPage: (
    props: AdminBusinessManagementPageProps
  ) => ReactNode;
  public static AdminCategoryManagementPage: (
    props: AdminCategoryManagementPageProps
  ) => ReactNode;
  public static AdminConfigurationPage: (
    props: AdminConfigurationPageProps
  ) => ReactNode;
  public static AdminDashboardPage2: (
    props: AdminDashboardPage2Props
  ) => ReactNode;
  public static AdminHomePage: (props: AdminHomePageProps) => ReactNode;
  public static AdminLoginPage: (props: AdminLoginPageProps) => ReactNode;
  public static AdminSignupPage: (props: AdminSignupPageProps) => ReactNode;
}
